var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.show
    ? _c(
        "div",
        {
          staticClass: "popup-container",
          on: {
            click: function ($event) {
              if ($event.target !== $event.currentTarget) return null
              return _vm.$emit("click-overlay")
            },
          },
        },
        [
          _c("div", { staticClass: "popup-content" }, [
            _c("div", { staticClass: "popup-header" }, [
              !!_vm.title
                ? _c("span", { staticClass: "popup-title" }, [
                    _vm._v(_vm._s(_vm.title)),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.closeable
                ? _c("i", {
                    staticClass: "icon icon-close popup-icon",
                    on: {
                      click: function ($event) {
                        return _vm.$emit("click-close-icon")
                      },
                    },
                  })
                : _vm._e(),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "popup-body" }, [_vm._t("default")], 2),
          ]),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }